import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// material ui components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';

//icons
import ChevronRight from '@material-ui/icons/ChevronRight';
import SaveIcon from '@material-ui/icons/Save';
import OpenIcon from '@material-ui/icons/OpenInNew';

//styles
import useStyles from './styles';

// //hooks
import { usePouchDB } from '../../../components/PouchDB/PouchDBProvider';
import { useSnackbar } from 'notistack';

import PouchDB from 'pouchdb-browser';
import PouchDBFind from 'pouchdb-find';
import PouchDBAuth from 'pouchdb-authentication';
import { remote, local } from '../../../config/db';

//app components
import { ScrollToTopWithoutRouter } from '../../../components/ScrollToTop';
import { Swipeable } from 'react-swipeable';
import isInt from 'validator/lib/isInt';

// redux implementation
import { withRouter } from "react-router-dom";
import { compose } from "redux";

// axios
import axios from 'axios';

// file-upload
import { DropzoneArea, DropzoneDialog, FileItem } from 'material-ui-dropzone'

PouchDB.plugin(PouchDBFind);
PouchDB.plugin(PouchDBAuth, { skip_setup: true });

const API_URL = process.env.REACT_APP_API_DEVELOPMENT_URL
export const dataFrontend = new PouchDB('frontend');

function Profile({ history }) {
    const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY
    // const db_name = localStorage.getItem("db_name")
    // const remote_base = localStorage.getItem("remote_base")
    // const url = remote_base + '/' + db_name
    // const couchdb = remote_base.split('/')[4]

    const classes = useStyles();
    const nextRef = useRef(null)
    const { user: { metadata }, dataKK, dataKB, dataPK, dataBkkbn, dataRekap } = usePouchDB();
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState({})

    // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
    const [isSaved, setSaved] = useState({
        local: false,
        remote: false
    })

    const [user, setUser] = useState({
        isLoggedIn: false,
        loading: true
    })

    const [auth, setAuth] = useState({})
    const [files, setFiles] = React.useState([]);
    const [open, setOpen] = useState(false)

    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);
    };

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleSave = (files) => {
        //Saving files to state for further use and closing Modal.
        setFiles(files)
        setOpen(false)
    }

    // GET ALL DATA
    useEffect(() => {
        const auth = new PouchDB(remote.users);
        setAuth(auth);
        const getSession = async () => {

            setUser(user => ({ ...user, loading: true }))

            try {
                //step 2 login if sudah login
                const localsession = await dataFrontend.get('auth');

                setUser(localsession.authData)

                try {
                    const newData = await getData(localsession.authData.name, localsession.authData.id)

                    const userCtx = {
                        name: newData.userProfile.nameProses,
                        roles: newData.userProfile.roles,
                        id: newData.id,
                        ipAddress: newData.ipAddress,
                        jsessionid: newData.jsessionid,
                        flagFirstLogin: newData.flagFirstLogin
                    }

                    const metadata = newData.userProfile

                    setUser(user => ({
                        ...user,
                        ...userCtx,
                        isLoggedIn: true,
                        metadata,
                    }))

                    const authData = {
                        ...userCtx,
                        isLoggedIn: true,
                        metadata,
                    }

                    try {
                        await dataFrontend.put({
                            _id: 'auth',
                            authData,
                        })

                    } catch (error) {
                        await dataFrontend.remove(localsession);
                        await dataFrontend.put({
                            _id: 'auth',
                            authData,
                        })
                    }

                } catch (error) {
                    //console.log("eror getdata ", error)
                }

            } catch (e) {
                setUser({
                    isLoggedIn: false,
                    loading: false
                })
            }
            setUser(user => ({ ...user, loading: false }))
        }
        getSession()
    }, [user.isLoggedIn])

    const getData = async (name, id) => {
        try {
            const data = await axios.get(`${API_URL}/auth/getUser?name=${name}&q=${id}&user_key=5848e56474b2baefc07afe94bff01afa`, {
                headers: {
                    withCredentials: true,
                    'Content-Type': 'application/json',
                    Authorization: 'Basic YWRtaW46cGFzc3dvcmQ='
                }
            })
            return data.data

        } catch (error) {
            console.log(error)
        }
    }

    const textSubmit = () => {
        return (
            <>
                <Typography style={{ color: 'red' }}> SUBMIT </Typography>
            </>
        )
    }

    return (
        <div>
            <form
                // onSubmit={handleSubmit}
                className={classes.form}
            >
                <ScrollToTopWithoutRouter />
                <Grid container spacing={3}>

                    <Grid item xs={12} className={classes.textCenter}>
                        <Typography variant="h5" component="h1" style={{ marginTop: '5px' }}>Profile</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> ID Kader </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.name} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Nama Lengkap </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.nama_lengkap?.toUpperCase()} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> NIK </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.nik} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Alamat </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.alamat?.toUpperCase()} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> No. Telepon </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.notelepon} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Group </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.group?.toUpperCase()} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Status NPWP </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.status_npwp === true ? "Ada" : "Tidak Ada"} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> NPWP </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.npwp} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Status Pekerjaan </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.status_pekerjaan?.toUpperCase()} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> NIP </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.nip} </Typography>
                    </Grid>

                    <Grid item xs={4} md={4}>
                        <Typography> Golongan </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Typography> : {metadata.golongan} </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    {/* <DropzoneArea onChange={updateFiles} value={files}>
                        {files.map((file) => (
                            <File {...file} preview />
                        ))}
                    </DropzoneArea> */}

                    <Grid item xs={12} className={classes.textCenter}>
                        <Button size="large" variant="contained" color="primary" onClick={handleOpen}>
                            <OpenIcon className={classes.iconLeft} />
                            Open Upload File
                        </Button>
                        <DropzoneDialog
                            open={open}
                            onSave={handleSave}
                            acceptedFiles={['application/pdf']}
                            showPreviews={true}
                            maxFileSize={5000000}
                            onClose={handleClose}
                            cancelButtonText={"CANCEL"}
                            submitButtonText={"SUBMIT"}
                        />
                    </Grid>

                    <Grid item xs={12} className={classes.textCenter}>
                        <Typography style={{ marginTop: "10px", fontStyle: "italic" }}> Data yang dimasukkan sudah benar dan dapat dipertanggung jawabkan </Typography>
                    </Grid>

                </Grid>

            </form>
        </div>
    )
}

export default Profile;